import { render, staticRenderFns } from "./suppliersForm.vue?vue&type=template&id=3c7693b1&"
import script from "./suppliersForm.vue?vue&type=script&lang=js&"
export * from "./suppliersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports